module.exports = __webpack_public_path__ + "static/media/chevron-circle-right.4caa0c81.svg";